export class HolidaysResponse {
  zoneId?: number;
  profitCenterCode: string;
  schoolId?: number;
  fromDate: string;
  toDate: string;
}

export class HolidaysSchool {
  schoolId: number;
  holidays: Date[];
}

export class HolidaysSchoolRequest {
  zoneId: number;
  schoolId: number;
  exerciseId: number;
  addHolidays: String[];
  deleteHolidays: String[];
}

